import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { useMatch } from 'react-router-dom'
import { CONFIG } from '~/lib/config'
import { symbiosis } from '~/lib/symbiosis'
import { VESISConfig } from '~/types/config'

export interface VESISParams {
	config: VESISConfig
	provider: StaticJsonRpcProvider
}

export function useVESISParams(): VESISParams {
	const match = useMatch('/vesis/:network/*')

	const networkSlug = match?.params.network

	if (!networkSlug) {
		throw new Error(
			'Network slug not found. This hook should only be used on VESIS pages.'
		)
	}

	const networkConfig = CONFIG.vesis.find(
		(vesis) => vesis.slug === networkSlug
	)

	if (!networkConfig) {
		throw new Error(
			`Network not found: ${networkSlug}. This should never happen.`
		)
	}

	return {
		config: networkConfig,
		provider: symbiosis.getProvider(networkConfig.chain.id),
	}
}
